export enum SkeletonTypeEnum {
	POST_LIST = 'POST_LIST',
	HORIZONTAL_POST_LIST = 'HORIZONTAL_POST_LIST',
	POST_COVER = 'POST_COVER',
	POST_COVER_LIST = 'POST_COVER_LIST',
	EVENT = 'EVENT',
	COMMENT = 'COMMENT'
}
